// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Timeline from 'antd/lib/timeline';
import 'antd/lib/timeline/style/css';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/css';
// COMPONENTS
import SectionHeader from 'components/text/SectionHeader';

//------------------------------------------------------------------------------
// AUX FUNCTIONS:
//------------------------------------------------------------------------------

const ActivityAreaContainer = ({ children, loading }) => (
  <div style={{ marginTop: 25 }}>
    <div style={{ position: 'relative' }}>
      <SectionHeader>Recent Activity</SectionHeader>
    </div>
    <Card loading={loading} style={{ height: 370, overflowY: 'scroll' }} bodyStyle={{ padding: 10, paddingTop: 18 }}>
      <Timeline>{children}</Timeline>
    </Card>
  </div>
);

export default ActivityAreaContainer;



// WEBPACK FOOTER //
// ./src/routes/app-home/OrganizationTransactions/ActivityAreaContainer.js